import React from "react";
import { Chart } from "react-google-charts";

export const data1 = [
  ["Year", "Sales", "Expenses", "Profit"],
  ["2014", 1000, 400, 200],
  ["2015", 1170, 460, 250],
  ["2016", 660, 1120, 300],
  ["2017", 1030, 540, 350],
];

const options = {
  chart: {
    title: "Company Performance",
    subtitle: "Sales, Expenses, and Profit: 2014-2017",
    colors: [
      "#e7711c", 
      "#808000", 
      "#00FF00", 
      "#008000", 
      "#00FFFF", 
      "#008080", 
      "#0000FF", 
      "#000080", 
      "#FF00FF", 
      "#80008"],
  },
};

export default function App(props) {
    let {title, subtitle, reports, data} = props
    options.chart.title = title || ''
    options.chart.subtitle = subtitle || ''

    let rows = [['Report', 'Average']]
    Object.keys(data).forEach(element => {
        rows.push([reports[element], data[element]])
    });



  return (
    <Chart
      chartType="Bar"
      width="100%"
      height="400px"
      data={rows}
      options={options}
    />
  );
}
